<template>
  <q-card flat>
    <q-card-section class="no-padding fixed-header-position">
      <q-banner class="bg-primary text-white" inline-actions>
        {{ getTitle() }}
      </q-banner>
      <q-card-section class="no-padding bg-white">
        <CustomerSearchPanel @layout-changed="layoutChanged"
                             :is-buy-and-sale-list="$route.params.type==='0'"
                             :buy-list="$route.params.type!=='1'"/>
      </q-card-section>
    </q-card-section>
    <q-card-section class="no-padding">
      <CustomersList v-if="grdShowType!=='simple' && $route.params.type!=='0'"
                     :is-only-search-list="true"
                     :items="[]"
                     :is-dialog="false"
                     :title="$route.params.type==='0'?'تامین کنندگان و مشتریان':''"
                     :is-buy-and-sale-list="$route.params.type==='0'"
                     :buy-list="$route.params.type!=='1' && $route.params.type!=='0'"/>
      <CustomersListSimple v-if="(grdShowType==='simple' && !$q.screen.lt.md) || $route.params.type==='0'"
                           :is-only-search-list="true"
                           :items="[]"
                           :is-dialog="false"
                           :title="$route.params.type==='0'?'تامین کنندگان و مشتریان':''"
                           :is-buy-and-sale-list="$route.params.type==='0'"
                           :buy-list="$route.params.type!=='1' && $route.params.type!=='0'"/>

    </q-card-section>
    <q-dialog
        :full-width="$q.screen.lt.md"
        v-model="showInsertCustomerDialog">
      <q-card>
        <q-card-section>
          <CUCustomerInfo action="insert" @customer-updated="customerUpdated"/>
        </q-card-section>
      </q-card>
    </q-dialog>
  </q-card>
</template>

<script>
import CustomerSearchPanel from "@/components/customers/CustomerSearchPanel";
import CUCustomerInfo from "@/components/customers/CUCustomerInfo";
import {mapActions} from "vuex";
import CustomersList from "@/components/customers/CustomersList";
import CustomersListSimple from "@/components/customers/CustomersListSimple.vue";

export default {
  name: "CustomerSearch",
  components: {CustomersListSimple, CustomersList, CUCustomerInfo, CustomerSearchPanel},
  data() {
    return {
      showInsertCustomerDialog: false,
      grdShowType: undefined
    }
  },
  methods: {
    ...mapActions({}),
    customerUpdated() {
      this.showInsertCustomerDialog = false;
    },
    layoutChanged(args) {
      this.grdShowType = args
    },
    getTitle() {
      if (this.$route.params.type === '0') {
        return 'تامین کنندگان و مشتریان'
      } else if (this.$route.params.type === '1') {
        return 'مشتریان'
      } else if (this.$route.params.type === '2') {
        return 'تامین کنندگان'
      }
    }
  },
  meta() {
    return {
      title: "بانک اطلاعاتی طرف معامله",
    }
  }
}
</script>

<style scoped>
.fixed-header-position {
  position: sticky;
  top: 50px;
  z-index: 1000
}
</style>
